import React from 'react'
import block from 'bem-cn'

import { usePopupControls } from 'shared/hooks/usePopupControls'

import { ControllerWrapperSharedProps } from 'components/UIKit/ControllerWrapper'
import { DatePickerCalendarDate } from 'components/UIKit/DatePicker/DatePickerCalendarDate'
import { DatePickerProvider } from 'components/UIKit/DatePicker/DatePickerProvider'
import { DatePickerOnChangeFunction, DatePickerVariant, IntervalVariants } from 'components/UIKit/DatePicker/types'
import { DropdownHorizontalPosition, DropdownVerticalPosition } from 'components/UIKit/Dropdown'

import './DatePicker.scss'

export type DatePickerProps = ControllerWrapperSharedProps & {
  value: Date | null
  name?: string
  placeholder?: string
  disabledDates?: Date[]
  interval?: IntervalVariants
  setInterval?: (interval: IntervalVariants) => void
  horizontalPosition?: DropdownHorizontalPosition
  verticalPosition?: DropdownVerticalPosition
  maxDate?: Date
  minDate?: Date
  onChange?: (date: Date) => void
  onError?: (error: string) => void
  isInputAvailable?: boolean
}

const b = block('date-picker')

export const DatePicker: React.FC<DatePickerProps> = ({
  onChange,
  value,
  horizontalPosition,
  verticalPosition,
  setInterval,
  disabledDates,
  minDate,
  maxDate,
  isInputAvailable,
  interval = IntervalVariants.DAY,
  onError,
  ...rest
}) => {
  const dropdownControls = usePopupControls()

  return (
    <DatePickerProvider
      value={value}
      variant={DatePickerVariant.DATE}
      onChange={onChange as DatePickerOnChangeFunction}
      horizontalPosition={horizontalPosition}
      verticalPosition={verticalPosition}
      disabledDates={disabledDates}
      maxDate={maxDate}
      modalControls={dropdownControls}
      minDate={minDate}
      interval={interval}
      isInputAvailable={isInputAvailable}
      onError={onError}
      setInterval={setInterval}>
      <DatePickerCalendarDate {...rest} />
    </DatePickerProvider>
  )
}
